module.exports = __webpack_public_path__ + "img/60.714c5882.jpg";